// Generate a random pastel color
export function generateRandomPastelColor() {
    const hue = Math.floor(Math.random() * 360);
    const saturation = Math.floor(Math.random() * 30) + 70; // 70-100%
    const lightness = Math.floor(Math.random() * 20) + 70; // 70-90%
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

// Adjust color lightness
export function adjustColorLightness(color, amount) {
    const hsl = color.match(/\d+/g).map(Number);
    if (hsl && hsl.length === 3) {
        hsl[2] = Math.max(0, Math.min(100, hsl[2] + amount));
        return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
    }
    return color;
}

// Convert HSL to RGB
export function hslToRgb(h, s, l) {
    h /= 360;
    s /= 100;
    l /= 100;
    let r, g, b;

    if (s === 0) {
        r = g = b = l;
    } else {
        const hue2rgb = (p, q, t) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1/6) return p + (q - p) * 6 * t;
            if (t < 1/2) return q;
            if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        };

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

// Convert RGB to Hex
export function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

// Generate a color palette
export function generateColorPalette(baseColor, count) {
    const palette = [baseColor];
    const hsl = baseColor.match(/\d+/g).map(Number);
    
    for (let i = 1; i < count; i++) {
        const newHue = (hsl[0] + i * (360 / count)) % 360;
        palette.push(`hsl(${newHue}, ${hsl[1]}%, ${hsl[2]}%)`);
    }

    return palette;
}